import { parseFrontendError } from "@/fe-core/helpers/general";
import { IJackpotDetailsViewModel } from "@/fe-core/meta/interfaces/jackpotDetails";
import { jackpotDetailsActionTypes } from "@/fe-core/meta/types/jackpotDetails";
import {
  all,
  AllEffect,
  ForkEffect,
  put,
  takeLatest,
} from "redux-saga/effects";
import { IJsonResponse } from "../../meta/interfaces/root";
import { methodTypes } from "../../meta/types/root";
import {
  getJackpotDetailsFailure,
  getJackpotDetailsSuccess,
} from "../actions/jackpotDetailsActions";

function* getJackpotDetailsSaga() {
  try {
    const response: IJsonResponse<IJackpotDetailsViewModel> = yield fetch(
      `/api/jackpotDetails`,
      {
        method: methodTypes.GET,
      }
    );
    const { status } = response;
    switch (status) {
      case 200:
        const viewModel: IJackpotDetailsViewModel = yield response.json();
        yield put(getJackpotDetailsSuccess(viewModel));
        break;
      default:
        throw new Error("Jackpot Details couldn't be fetched");
    }
  } catch (error) {
    yield put(getJackpotDetailsFailure(parseFrontendError(error)));
  }
}

function* jackpotDetailsSaga(): Generator<
  AllEffect<ForkEffect<never>>,
  void,
  unknown
> {
  yield all([
    takeLatest(
      jackpotDetailsActionTypes.GET_JACKPOT_DETAILS_REQUEST,
      getJackpotDetailsSaga
    ),
  ]);
}

export default jackpotDetailsSaga;
